// Паша прости
export var container = {
    position: 'absolute',
    right: 5,
    top: 25,
    zIndex: 1
};
export var button = {
    display: 'block',
    boxSizing: 'content-box',
    background: '0 0 #fff no-repeat',
    color: 'inherit',
    font: 'inherit',
    lineHeight: 'normal',
    overflow: 'visible',
    userSelect: 'none',
    position: 'relative',
    zIndex: 2,
    margin: 0,
    padding: 0,
    outline: 0,
    border: 0,
    cursor: 'pointer',
    width: 44,
    height: 44,
    borderRadius: 44,
    opacity: 0.92,
    transition: 'opacity .1s ease-out',
    boxShadow: '0 2px 3px 1px rgba(0, 0, 0, .2)',
    fontSize: 14
};
